var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconServ05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{clip-path:url(#SVGID_00000172441632412471551580000015353989189216263848_);fill:url(#SVGID_00000132076750007701897280000008408441245166795168_);}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000003796841751049934190000001819601512747373725_);fill:url(#SVGID_00000163759314703683175850000004344011789540121755_);}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000013891776830395502600000002217980623350402722_);fill:url(#SVGID_00000158024681695978537080000007972455765752697758_);}\n\t\n\t\t.st3{clip-path:url(#SVGID_00000085229282525155798210000001134356325090641824_);fill:url(#SVGID_00000149378090393459712440000012467185630126640002_);}\n\t\n\t\t.st4{clip-path:url(#SVGID_00000065060472731421973080000005364206056443260314_);fill:url(#SVGID_00000008852831439806919200000008064760110022551208_);}\n\t\n\t\t.st5{clip-path:url(#SVGID_00000173840228126390341580000015336277692271483797_);fill:url(#SVGID_00000021820437597819295880000007394020160775303844_);}\n\t\n\t\t.st6{clip-path:url(#SVGID_00000023982493014720397590000013580838652939564703_);fill:url(#SVGID_00000160899163757690132770000005301910333796079250_);}\n\t\n\t\t.st7{clip-path:url(#SVGID_00000003076091706181665060000016159658975743200953_);fill:url(#SVGID_00000073705320448790585210000010680261596493884558_);}\n\t\n\t\t.st8{clip-path:url(#SVGID_00000065788044701218192010000007254754032361150127_);fill:url(#SVGID_00000070088133322050274000000004488846798215723170_);}\n\t\n\t\t.st9{clip-path:url(#SVGID_00000031172519027932337700000006565645980221155241_);fill:url(#SVGID_00000106828708009720299770000016730899252084669339_);}\n\t\n\t\t.st10{clip-path:url(#SVGID_00000048502087058099534380000014474227324348960167_);fill:url(#SVGID_00000031896709363292358630000003335688355410636458_);}\n\t\n\t\t.st11{clip-path:url(#SVGID_00000138556322298958853530000012442465933973463994_);fill:url(#SVGID_00000129167358542275388860000006515794346037991583_);}\n\t\n\t\t.st12{clip-path:url(#SVGID_00000085941329183397607080000003148821854791884705_);fill:url(#SVGID_00000117661042243618995650000010765411033916122264_);}\n\t\n\t\t.st13{clip-path:url(#SVGID_00000103223413008946026260000016207773825639715239_);fill:url(#SVGID_00000118367210970660172770000001158676511552425631_);}\n\t\n\t\t.st14{clip-path:url(#SVGID_00000170999015720512292390000008006624863926427050_);fill:url(#SVGID_00000018230595510117676560000009371964799006515094_);}\n\t\n\t\t.st15{clip-path:url(#SVGID_00000145016739848094438410000017151698226335467696_);fill:url(#SVGID_00000032622724399854245730000008816181679719438741_);}\n\t\n\t\t.st16{clip-path:url(#SVGID_00000137829267764801583330000018239578751292337057_);fill:url(#SVGID_00000101067117544470912480000008084265959618303891_);}\n\t\n\t\t.st17{clip-path:url(#SVGID_00000017477090774542117170000008723017805768673202_);fill:url(#SVGID_00000112628678977528438430000008287263994004267705_);}\n\t\n\t\t.st18{clip-path:url(#SVGID_00000160157473664256136460000001952913343731991982_);fill:url(#SVGID_00000021829225524797663140000017501638590872557480_);}\n\t\n\t\t.st19{clip-path:url(#SVGID_00000149361616006946789730000000182556827989725578_);fill:url(#SVGID_00000046324860070013216670000008955776084111656612_);}\n\t\n\t\t.st20{clip-path:url(#SVGID_00000018235162076840128530000007285154744117947527_);fill:url(#SVGID_00000105391700940235553020000012323950692397651867_);}\n\t\n\t\t.st21{clip-path:url(#SVGID_00000124148214762727177340000013414602528491445399_);fill:url(#SVGID_00000070085774504308574290000002783578229745849506_);}\n\t\n\t\t.st22{clip-path:url(#SVGID_00000099636791259421727760000009364273711125846200_);fill:url(#SVGID_00000169527229929093495210000014014072168793783201_);}\n\t\n\t\t.st23{clip-path:url(#SVGID_00000010989036708935864090000018302356754484994461_);fill:url(#SVGID_00000076583399598074849720000009874356626268489108_);}\n\t\n\t\t.st24{clip-path:url(#SVGID_00000047745353012017056860000017934147430227959951_);fill:url(#SVGID_00000002369473101856278610000017320104923592232635_);}\n\t\n\t\t.st25{clip-path:url(#SVGID_00000178182275077582890030000011243956530722527152_);fill:url(#SVGID_00000061436557627653101330000008796811976268362630_);}\n\t\n\t\t.st26{clip-path:url(#SVGID_00000067928800206815807710000016313269442184669629_);fill:url(#SVGID_00000087377736482962328490000005108525440346774687_);}\n\t\n\t\t.st27{clip-path:url(#SVGID_00000119105926315957397830000003830093612611914167_);fill:url(#SVGID_00000114764405875035046660000017263704889391019153_);}\n\t\n\t\t.st28{clip-path:url(#SVGID_00000106135907390000763050000014801839253941583274_);fill:url(#SVGID_00000182497494847727570660000008375607270188386480_);}\n\t\n\t\t.st29{clip-path:url(#SVGID_00000005252333068565841930000012663284561298807473_);fill:url(#SVGID_00000034075513565792231270000012272303801700097209_);}\n\t\n\t\t.st30{clip-path:url(#SVGID_00000044174563326692326970000001783532257534113209_);fill:url(#SVGID_00000163032213717766603510000016822418503710237839_);}\n\t\n\t\t.st31{clip-path:url(#SVGID_00000044147135329497184540000004642856487070091137_);fill:url(#SVGID_00000014621667329215879520000001555896987484904861_);}\n\t\n\t\t.st32{clip-path:url(#SVGID_00000122713785931931347820000008354622123386344110_);fill:url(#SVGID_00000124126228839543471900000002363852367686035588_);}\n\t\n\t\t.st33{clip-path:url(#SVGID_00000143582910010524797250000002569713409092018103_);fill:url(#SVGID_00000130616634729954908430000001823464544452698240_);}\n\t\n\t\t.st34{clip-path:url(#SVGID_00000157290457048631904750000007818114631108385944_);fill:url(#SVGID_00000085225392211354712370000011070138318601827763_);}\n\t\n\t\t.st35{clip-path:url(#SVGID_00000031914764117224861440000003939985236837760445_);fill:url(#SVGID_00000129164265422213677410000007799444223511844225_);}\n\t\n\t\t.st36{clip-path:url(#SVGID_00000040577124029662872880000001746494007457177494_);fill:url(#SVGID_00000098938525262711910270000008544185386036711296_);}\n\t\n\t\t.st37{clip-path:url(#SVGID_00000181079753087289830190000014750464669345078678_);fill:url(#SVGID_00000160152539804457791620000001196188077045329845_);}\n\t\n\t\t.st38{clip-path:url(#SVGID_00000029748835719272340430000013254783042232277653_);fill:url(#SVGID_00000056393794988489457700000012462361485438168454_);}\n\t\n\t\t.st39{clip-path:url(#SVGID_00000088824802247116231190000017857089245389155257_);fill:url(#SVGID_00000021821884667349207530000016211198223233977513_);}\n\t\n\t\t.st40{clip-path:url(#SVGID_00000085949139069825347980000014489321740509228475_);fill:url(#SVGID_00000183945813166252122040000017514844281512709055_);}\n\t\n\t\t.st41{clip-path:url(#SVGID_00000013181264577751614000000001248543191059784069_);fill:url(#SVGID_00000057135207005059114650000000193664980492925113_);}\n\t\n\t\t.st42{clip-path:url(#SVGID_00000056414888538886527240000002155777805209231790_);fill:url(#SVGID_00000169519125603105574990000004198149478701002631_);}\n\t\n\t\t.st43{clip-path:url(#SVGID_00000112606621061366450920000009778493533551718030_);fill:url(#SVGID_00000150805779730809472660000010354575123069289644_);}\n\t\n\t\t.st44{clip-path:url(#SVGID_00000144313074743734271860000008762424980956898696_);fill:url(#SVGID_00000168799657582998778470000009725220598301298572_);}\n\t\n\t\t.st45{clip-path:url(#SVGID_00000089571355491240458920000000814224999589286045_);fill:url(#SVGID_00000053517978764572083340000011168562121183667072_);}\n\t\n\t\t.st46{clip-path:url(#SVGID_00000163071720679794631660000006226261004081738661_);fill:url(#SVGID_00000083804274347303694030000001114974108699219333_);}\n\t\n\t\t.st47{clip-path:url(#SVGID_00000182517251307412845730000005308226992440374162_);fill:url(#SVGID_00000150104440404269447190000002124389127473953675_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000054255513360493976510000015368735535663656374_",
    d: "M12.9,14.1c-0.4,0-0.7,0.3-0.7,0.7 c0,0.4,0.3,0.7,0.7,0.7h19.9v1.6c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7v-1.6h12v19h-12v-1.6c0-0.4-0.3-0.7-0.7-0.7 c-0.4,0-0.7,0.3-0.7,0.7v1.6h-29v-19h1.7c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.7-0.7-0.7H3.2c-0.4,0-0.7,0.3-0.7,0.7v20.4 c0,0.4,0.3,0.7,0.7,0.7h43.7c0.4,0,0.7-0.3,0.7-0.7V14.8c0-0.4-0.3-0.7-0.7-0.7H12.9z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091705526325687555740000011925650506215295159_",
    gradientUnits: "userSpaceOnUse",
    x1: 25,
    y1: 36.145,
    x2: 25,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054255513360493976510000015368735535663656374_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000091705526325687555740000011925650506215295159_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173853721140045854850000000069432432051122347_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054255513360493976510000015368735535663656374_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159440483152740786090000007319268825339179666_",
    gradientUnits: "userSpaceOnUse",
    x1: 25,
    y1: 36.145,
    x2: 25,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 14.1,
    style: {
      clipPath: "url(#SVGID_00000173853721140045854850000000069432432051122347_)",
      fill: "url(#SVGID_00000159440483152740786090000007319268825339179666_)"
    },
    width: 45,
    height: 21.7
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000132050065237132402360000012786479583353780412_",
    d: "M32.8,28.2v2.3c0,0.4,0.3,0.7,0.7,0.7 c0.4,0,0.7-0.3,0.7-0.7v-2.3c0-0.4-0.3-0.7-0.7-0.7C33.1,27.6,32.8,27.9,32.8,28.2"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124156223814874961360000012321455408193241728_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.4655,
    y1: 36.145,
    x2: 33.4655,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132050065237132402360000012786479583353780412_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000124156223814874961360000012321455408193241728_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129886677847550587990000014241809107695299775_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132050065237132402360000012786479583353780412_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134968360131774529870000000378382378875627960_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.4655,
    y1: 36.145,
    x2: 33.4655,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 32.8,
    y: 27.6,
    style: {
      clipPath: "url(#SVGID_00000129886677847550587990000014241809107695299775_)",
      fill: "url(#SVGID_00000134968360131774529870000000378382378875627960_)"
    },
    width: 1.3,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000150078362017135155430000009376162756727058098_",
    d: "M32.8,23.6v2.3c0,0.4,0.3,0.7,0.7,0.7 c0.4,0,0.7-0.3,0.7-0.7v-2.3c0-0.4-0.3-0.7-0.7-0.7C33.1,22.9,32.8,23.2,32.8,23.6"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101790105535654027460000017945036833230033057_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.4655,
    y1: 36.145,
    x2: 33.4655,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150078362017135155430000009376162756727058098_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000101790105535654027460000017945036833230033057_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000099637051029954009310000007112280191003821718_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150078362017135155430000009376162756727058098_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077291826349042879540000007448507494854534589_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.4655,
    y1: 36.145,
    x2: 33.4655,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 32.8,
    y: 22.9,
    style: {
      clipPath: "url(#SVGID_00000099637051029954009310000007112280191003821718_)",
      fill: "url(#SVGID_00000077291826349042879540000007448507494854534589_)"
    },
    width: 1.3,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000121240455097908405320000008032436607115650958_",
    d: "M32.8,19.2v2.3c0,0.4,0.3,0.7,0.7,0.7 c0.4,0,0.7-0.3,0.7-0.7v-2.3c0-0.4-0.3-0.7-0.7-0.7C33.1,18.5,32.8,18.8,32.8,19.2"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081644152521696015140000002502912199373605820_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.4655,
    y1: 36.145,
    x2: 33.4655,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121240455097908405320000008032436607115650958_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000081644152521696015140000002502912199373605820_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067950602084311213190000000105768780433689020_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121240455097908405320000008032436607115650958_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124143545992682994250000013648095451481705913_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.4655,
    y1: 36.145,
    x2: 33.4655,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 32.8,
    y: 18.5,
    style: {
      clipPath: "url(#SVGID_00000067950602084311213190000000105768780433689020_)",
      fill: "url(#SVGID_00000124143545992682994250000013648095451481705913_)"
    },
    width: 1.3,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000089575823851627951620000015361992630970367407_",
    d: "M15.5,28.1c-0.4,0-0.7,0.3-0.7,0.7 c0,0.4,0.3,0.7,0.7,0.7h12.7v1.8h-20v-1.8h1.3c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.7-0.7-0.7H7.5c-0.4,0-0.7,0.3-0.7,0.7v3.1 c0,0.4,0.3,0.7,0.7,0.7h21.3c0.4,0,0.7-0.3,0.7-0.7v-3.1c0-0.4-0.3-0.7-0.7-0.7H15.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047769910481022539810000016281771925636760469_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.1335,
    y1: 36.145,
    x2: 18.1335,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000089575823851627951620000015361992630970367407_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000047769910481022539810000016281771925636760469_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000001652073661084225590000011730841498526415537_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000089575823851627951620000015361992630970367407_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162314269554832166000000013433997416002957467_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.1335,
    y1: 36.145,
    x2: 18.1335,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6.8,
    y: 28.1,
    style: {
      clipPath: "url(#SVGID_00000001652073661084225590000011730841498526415537_)",
      fill: "url(#SVGID_00000162314269554832166000000013433997416002957467_)"
    },
    width: 22.7,
    height: 4.5
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000080181654294282471140000010122363156691244989_",
    d: "M43.7,22.6l-4,4L38,24.8c-0.3-0.3-0.7-0.3-0.9,0 c-0.3,0.3-0.3,0.7,0,0.9l2.2,2.2c0.1,0.1,0.3,0.2,0.5,0.2s0.3-0.1,0.5-0.2l4.5-4.5c0.3-0.3,0.3-0.7,0-0.9 c-0.1-0.1-0.3-0.2-0.5-0.2C44,22.4,43.8,22.5,43.7,22.6"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130611309641810516030000002627297946384958347_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.85,
    y1: 36.145,
    x2: 40.85,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080181654294282471140000010122363156691244989_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000130611309641810516030000002627297946384958347_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016784910018575061940000000658149708042325170_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080181654294282471140000010122363156691244989_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015332647135820202220000016126394990402287544_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.85,
    y1: 36.145,
    x2: 40.85,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36.8,
    y: 22.4,
    style: {
      clipPath: "url(#SVGID_00000016784910018575061940000000658149708042325170_)",
      fill: "url(#SVGID_00000015332647135820202220000016126394990402287544_)"
    },
    width: 8.1,
    height: 5.8
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000058567289114042285880000015417795686216833696_",
    d: "M7.4,21.3C7.2,21.7,7,22.1,7,22.8 c0,0.6,0.1,1.1,0.4,1.4c0.2,0.3,0.6,0.5,1,0.5c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.4-0.5,0.5-0.9l-0.6-0.2c-0.1,0.3-0.1,0.5-0.3,0.6 C8.7,24,8.6,24,8.4,24c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.2-0.2-0.5-0.2-1c0-0.4,0.1-0.8,0.2-1c0.1-0.2,0.3-0.3,0.5-0.3 c0.2,0,0.3,0.1,0.4,0.2C8.9,21.7,9,21.9,9,22.1l0.6-0.2c-0.1-0.3-0.2-0.6-0.4-0.7c-0.2-0.2-0.5-0.3-0.9-0.3 C8,20.8,7.7,21,7.4,21.3"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106129147943716921800000002296667074073863831_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.3336,
    y1: 36.145,
    x2: 8.3336,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000058567289114042285880000015417795686216833696_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000106129147943716921800000002296667074073863831_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054237475379149343710000002117129682574437559_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000058567289114042285880000015417795686216833696_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107572296726716373150000006089702533553335203_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.3336,
    y1: 36.145,
    x2: 8.3336,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 20.8,
    style: {
      clipPath: "url(#SVGID_00000054237475379149343710000002117129682574437559_)",
      fill: "url(#SVGID_00000107572296726716373150000006089702533553335203_)"
    },
    width: 2.6,
    height: 3.8
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000088845299984096615570000004891948346023176834_",
    d: "M10.9,23.7c-0.2-0.2-0.2-0.5-0.2-1c0-0.4,0.1-0.8,0.2-1 c0.2-0.2,0.4-0.3,0.6-0.3s0.5,0.1,0.6,0.3c0.2,0.2,0.2,0.5,0.2,1c0,0.4-0.1,0.8-0.2,1C12,23.9,11.8,24,11.5,24 C11.3,24,11.1,23.9,10.9,23.7 M10.8,21c-0.2,0.1-0.4,0.4-0.5,0.6c-0.1,0.3-0.2,0.6-0.2,1.1c0,0.6,0.1,1.1,0.4,1.4 c0.3,0.3,0.6,0.5,1,0.5c0.4,0,0.8-0.2,1-0.5c0.3-0.3,0.4-0.8,0.4-1.5c0-0.6-0.1-1.1-0.4-1.4c-0.3-0.3-0.6-0.5-1.1-0.5 C11.2,20.8,11,20.9,10.8,21"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088850337486417663790000016551792094968888240_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.5309,
    y1: 36.145,
    x2: 11.5309,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088845299984096615570000004891948346023176834_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000088850337486417663790000016551792094968888240_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070093059159483861480000008402605965131837335_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088845299984096615570000004891948346023176834_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058569423320546636420000004149550962876319638_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.5309,
    y1: 36.145,
    x2: 11.5309,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.1,
    y: 20.8,
    style: {
      clipPath: "url(#SVGID_00000070093059159483861480000008402605965131837335_)",
      fill: "url(#SVGID_00000058569423320546636420000004149550962876319638_)"
    },
    width: 2.9,
    height: 3.8
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000093139401733028839740000017253861633650458303_",
    points: "13.5,24.6 13.5,20.9 14.1,20.9 15.3,23.4  15.3,20.9 15.9,20.9 15.9,24.6 15.3,24.6 14.1,22.2 14.1,24.6  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145743722971032559340000011895809129786616226_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.7001,
    y1: 36.145,
    x2: 14.7001,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093139401733028839740000017253861633650458303_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000145743722971032559340000011895809129786616226_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142870769336766169590000007797667699473197955_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093139401733028839740000017253861633650458303_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011008162423386661480000011771288682194927768_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.7001,
    y1: 36.145,
    x2: 14.7001,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 20.9,
    style: {
      clipPath: "url(#SVGID_00000142870769336766169590000007797667699473197955_)",
      fill: "url(#SVGID_00000011008162423386661480000011771288682194927768_)"
    },
    width: 2.4,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000014606761372584828070000002745009220314267279_",
    points: "17.3,24.6 16.2,20.9 16.9,20.9 17.7,23.6  18.4,20.9 19.1,20.9 18,24.6  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088818869394211982860000012856337382369387668_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.6594,
    y1: 36.145,
    x2: 17.6594,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000014606761372584828070000002745009220314267279_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000088818869394211982860000012856337382369387668_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085936528377651420510000012288326467947291288_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000014606761372584828070000002745009220314267279_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156563301187247819540000005276799546709174924_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.6594,
    y1: 36.145,
    x2: 17.6594,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.2,
    y: 20.9,
    style: {
      clipPath: "url(#SVGID_00000085936528377651420510000012288326467947291288_)",
      fill: "url(#SVGID_00000156563301187247819540000005276799546709174924_)"
    },
    width: 2.8,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000141424089129276251230000009359427870389703606_",
    points: "19.4,24.6 19.4,20.9 21.6,20.9 21.6,21.5  20,21.5 20,22.3 21.5,22.3 21.5,23 20,23 20,24 21.7,24 21.7,24.6  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113348103513160172240000008334114926229900722_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.5423,
    y1: 36.145,
    x2: 20.5423,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000141424089129276251230000009359427870389703606_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000113348103513160172240000008334114926229900722_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000177483912882593247870000013170505155416856736_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000141424089129276251230000009359427870389703606_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055690732324832626710000006304756205115637146_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.5423,
    y1: 36.145,
    x2: 20.5423,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 19.4,
    y: 20.9,
    style: {
      clipPath: "url(#SVGID_00000177483912882593247870000013170505155416856736_)",
      fill: "url(#SVGID_00000055690732324832626710000006304756205115637146_)"
    },
    width: 2.3,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000152247036217744987750000016381186799738570894_",
    points: "22.2,24.6 22.2,20.9 22.8,20.9 24.1,23.4  24.1,20.9 24.6,20.9 24.6,24.6 24,24.6 22.8,22.2 22.8,24.6  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060720361809252443340000014384853621622014902_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.4299,
    y1: 36.145,
    x2: 23.4299,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152247036217744987750000016381186799738570894_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000060720361809252443340000014384853621622014902_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000141454190025060606200000010715010061738177960_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152247036217744987750000016381186799738570894_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093175138881337547860000016508913924839420044_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.4299,
    y1: 36.145,
    x2: 23.4299,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 22.2,
    y: 20.9,
    style: {
      clipPath: "url(#SVGID_00000141454190025060606200000010715010061738177960_)",
      fill: "url(#SVGID_00000093175138881337547860000016508913924839420044_)"
    },
    width: 2.4,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000115508245160596725190000005052627076290531739_",
    x: 25.3,
    y: 20.9,
    width: 0.6,
    height: 3.7
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137830720743772751030000000844097417366225083_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.5693,
    y1: 36.145,
    x2: 25.5693,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000115508245160596725190000005052627076290531739_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000137830720743772751030000000844097417366225083_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124846851024647825890000005614978942903330946_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000115508245160596725190000005052627076290531739_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163041900848106044690000010902383409947851417_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.5693,
    y1: 36.145,
    x2: 25.5693,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 25.3,
    y: 20.9,
    style: {
      clipPath: "url(#SVGID_00000124846851024647825890000005614978942903330946_)",
      fill: "url(#SVGID_00000163041900848106044690000010902383409947851417_)"
    },
    width: 0.6,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000065032864087203349370000016361048053391207312_",
    d: "M27.2,23.7c-0.2-0.2-0.2-0.5-0.2-1c0-0.4,0.1-0.8,0.2-1 c0.2-0.2,0.4-0.3,0.6-0.3c0.2,0,0.5,0.1,0.6,0.3c0.2,0.2,0.2,0.5,0.2,1c0,0.4-0.1,0.8-0.2,1c-0.2,0.2-0.4,0.3-0.6,0.3 C27.6,24,27.4,23.9,27.2,23.7 M27,21c-0.2,0.1-0.4,0.4-0.5,0.6c-0.1,0.3-0.2,0.6-0.2,1.1c0,0.6,0.1,1.1,0.4,1.4 c0.3,0.3,0.6,0.5,1,0.5c0.4,0,0.8-0.2,1-0.5c0.3-0.3,0.4-0.8,0.4-1.5c0-0.6-0.1-1.1-0.4-1.4c-0.3-0.3-0.6-0.5-1.1-0.5 C27.5,20.8,27.3,20.9,27,21"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165913377405462881220000000676208059307972265_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.8128,
    y1: 36.145,
    x2: 27.8128,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065032864087203349370000016361048053391207312_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000165913377405462881220000000676208059307972265_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150062651876528868200000002118000124189223557_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065032864087203349370000016361048053391207312_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126284817604918304790000012007529063705013130_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.8128,
    y1: 36.145,
    x2: 27.8128,
    y2: 14.1164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 26.3,
    y: 20.8,
    style: {
      clipPath: "url(#SVGID_00000150062651876528868200000002118000124189223557_)",
      fill: "url(#SVGID_00000126284817604918304790000012007529063705013130_)"
    },
    width: 2.9,
    height: 3.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServ05);
export default __webpack_public_path__ + "static/media/IconServ-05.e51a058aa7d8f4c1044199b2549acaf6.svg";
export { ForwardRef as ReactComponent };